import { css } from '@emotion/react';
import * as breakpoints from '../../constants/breakpoints';
export default {
    tail: css `
  height: 1px;
  transition: width 0.15s ease-out;
  [data-with-tail-cta]:hover &, [data-with-tail-cta]:focus & {
      width: 30px;
    }
`,
    arrow: css `
    width: 8px;
    height: 8px;
    top: -1px;
    @media (min-width: ${breakpoints.LG}) {
      width: 10px;
      height: 10px;
      top: 0;
    }
  `,
};
